import React from 'react';
import styles from './CompaniesContainer.module.css';
import Input from '../shared/ui/Input/Input';
import SearchInput from '../shared/ui/Input/SearchInput';
import CompaniesTable from './CompaniesTable';


const CompaniesContainer = (props)=> (
    <div className={styles.Content} >
        <h1>Companies</h1>
        <div>
            <SearchInput/>
        </div>
        <CompaniesTable/>
    </div>
)

export default CompaniesContainer;